import { createContext } from 'react';
import { Target } from '../../../types';

export type FocusTargetOptions = { [username: string]: Target | undefined };

export const FocusTargetContext = createContext<FocusTargetOptions>({});
